// extracted by mini-css-extract-plugin
export default {"label":"ImageBanner_label__5B8K6"};